import { createContext, ReactNode } from "react";

type DialogSetter = {
  setDialogByUUID: (uuid: string, dialog: ReactNode) => void;
};

export const DialogContext = createContext<DialogSetter | undefined>(undefined);
